import { createNodeElements, putInfoIntoRightSideBar } from "/node/main_content_init.js";
import { createNodeExploreSection } from "/node/node_explore.js";
import { truncateNameAndDescription } from '/explore_field_functions/content_preview.js';
import { createLoadingScreen } from "/loading_screen_functions/loading_screen_functions.js";
import { createLeftSideContent } from '/left_side_functions/left_side_functions.js';
import { createPageHeader } from '/header_functions/header_functions.js';
import { createElement } from "/elements_functions/new_elements.js";
import {  SITE_URL, API_GATEWAY } from "/constants/API_constants.js";
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";
import { createContentRestrictedWindow } from "/restricted_content/restricted_content_functions.js";
import { createBranchCommentSectionWithObserverLoader } from "/node/comment_section.js";
import { createPlaque } from "/plaque/create_plaque.js";
import { createPlus18Screen } from '/restricted_content/censorship_screens.js';


initNodePage();

async function initNodePage() {
    const mainContent = document.getElementById('main-content');
    const loadingScreen = createLoadingScreen(450, 1400, 100);
    mainContent.append(loadingScreen);
    const body = document.querySelector('body');
    const main = document.querySelector('main');
    

    body.insertAdjacentElement('afterbegin', createPageHeader());

    const leftSection = document.getElementById('left-side-bar');
    leftSection.append(...createLeftSideContent(localStorage.getItem("branchof_access_token"), localStorage.getItem("branchof_access_profile_pic"),
        localStorage.getItem("branchof_access_username"), localStorage.getItem("branchof_access_profile_name")));
    
    const nodeId = getNodeId();
    
    const [nodeObject, authorInfo, likeStatus, subscriptionStatus] = await getNodeInfo(nodeId);
    
    if(nodeObject==='restricted') {
        const contentRestricted = createContentRestrictedWindow('This branch has been made unavailable by the moderation, most likely due to breaking community rules or engaging in indecent behavior.',
            'content-restricted-branch');
            
        loadingScreen.remove();
        mainContent.append(contentRestricted);
        
    } else if(nodeObject!==null) {
        nodeObject.id = nodeId;
        const subscribersCount = extractSubscribersCount(nodeObject);
        const exploreSection = createNodeExploreSection(nodeObject, subscriptionStatus, subscribersCount);
        main.append(exploreSection);
        const nodeMainElements = await createNodeElements(nodeId, nodeObject, authorInfo, likeStatus);

        const modStatus = nodeObject.modStatus;
        if(modStatus!==null) {
            if (modStatus==="plus_18") {
                const black18Screen = createPlus18Screen();

                black18Screen.create18WarningIconInBeginning();
                black18Screen.makeIconRhombus();
                black18Screen.createGoBackButton();

                const plaque = createPlaque();
    
                plaque.append(black18Screen);
                main.classList.add('blurred');
                plaque.style.padding = "0";
                black18Screen.style.height = "100%";

                black18Screen.black18ScreenButton.addEventListener('click', () => {
                    plaque.remove();
                    main.classList.remove('blurred');
                });
            }
        }
            
        loadingScreen.remove();
        mainContent.append(...nodeMainElements);
        postRenderFunction(main, nodeId);
    
        putInfoIntoRightSideBar(authorInfo);

        const commentSection = createBranchCommentSectionWithObserverLoader(nodeId);
        mainContent.append(commentSection);
    }
}

function getNodeId() {
    let nodeId = window.location.href;
    nodeId = nodeId.replace(SITE_URL + "/branch/view-page/", "");
    return nodeId;
}

async function getNodeInfo(nodeId) {

    let token = localStorage.branchof_access_token;
    let response = null;

    if(token===null || token===undefined) {
        response = await fetch(API_GATEWAY + 'branches/get/node&long-author/' + nodeId, {
            method : 'GET',
            headers : {
                'Accept' : 'application/json'
            }
        });
    } else {
        response = await fetch(API_GATEWAY + 'branches/get/node&long-author/' + nodeId, {
            method : 'GET',
            headers : {
                'Accept' : 'application/json',
                'Token-Auth' : `${token}`
            }
        });
    }

    if(response.status===200) {
        const data = await response.json();
    
        console.log(data);
        
        return [data.branch, data.userInfo, data.likeStatus, data.subscriptionStatus];
    } else if (response.status===204) {
        insertPlaqueAndAlertWindow("This branch doesn't exist");
        return  [null, null, null];
    } else if (response.status===401) {
        const data = await response.json();
    
        console.log(data);
        insertPlaqueAndAlertWindow("Your login session has expired");
        
        return [data.branch, data.userInfo, data.likeStatus, data.subscriptionStatus];
    } else if (response.status===403) {
        return  ['restricted', null, null];
    } else {
        insertPlaqueAndAlertWindow("Something went wrong while loading up the branch!");
        return  [null, null, null];
    }
        
}

function postRenderFunction(mainContent, nodeId) {
    const exploreMiniFieldWrapper = mainContent.querySelector('.explore-mini-field-wrapper');
    exploreMiniFieldWrapper.initiateAfterRender();

    const nodeInfoElement = mainContent.querySelector('#branch-info');
    nodeInfoElement.onRender();
    

    exploreMiniFieldWrapper.centerExploreFieldAroundTheBranch(nodeId);
}

function extractSubscribersCount(nodeObject) {
    
    const subscribersCount = nodeObject.subscribersCount;
    if(subscribersCount!==null && subscribersCount>0)
        return subscribersCount;

    if(nodeObject.parent!==null)
        return extractSubscribersCount(nodeObject.parent);

    return subscribersCount;
}